//     // import React, { Fragment } from 'react'
//     // import { Image, Text, View, Page, Document, StyleSheet, Font } from '@react-pdf/renderer';

//     // const Invoice = ({ data }) => {

//     //     const styles = StyleSheet.create({
//     //         page: {
//     //             padding: 20,
//     //             flexDirection: 'column',
//     //             margin: 5,
//     //         },
//     //         borderedContainer: {
//     //             fontSize: 11,
//     //             paddingTop: 0,
//     //             paddingLeft: 40,
//     //             paddingRight: 40,
//     //             paddingBottom: 20,
//     //             lineHeight: 1.5,
//     //             flexDirection: 'column',
//     //             border: '1px solid #000',
//     //         },

//     //         spaceBetween: { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', color: "#3E3E3E" },

//     //         titleContainer: { flexDirection: 'row', marginTop: 5 },

//     //         logo: { width: 90 },

//     //         reportTitle: { fontSize: 16, textAlign: 'center' },

//     //         addressTitle: { fontSize: 8, fontStyle: 'bold' },

//     //         invoice: { fontSize: 8 },

//     //         invoiceNumber: { fontSize: 8, fontWeight: 'bold' },

//     //         address: { fontSize: 8 },

//     //         boldAddressTitle: {
//     //             fontSize: 10,
//     //             fontFamily: 'Helvetica-Bold',
//     //         },

//     //         theader: {
//     //             marginTop: 20,
//     //             fontSize: 8,
//     //             fontWeight: 'bold',
//     //             paddingTop: 4,
//     //             paddingLeft: 7,
//     //             flex: 1,
//     //             height: 20,
//     //             backgroundColor: '#DEDEDE',
//     //             borderColor: 'whitesmoke',
//     //             borderRightWidth: 1,
//     //             borderBottomWidth: 1,
//     //             width:'auto',
//     //             alignItems:'center',
//     //             textAlign:'center'
//     //         },
//     //         theader2: {
//     //             flex: 2,
//     //             borderRightWidth: 0,
//     //             borderBottomWidth: 1,
//     //         },
//     //         tbody: {
//     //             fontSize: 9,
//     //             paddingTop: 4,
//     //             paddingLeft: 7,
//     //             flex: 1,
//     //             borderColor: 'whitesmoke',
//     //             borderRightWidth: 1,
//     //             borderBottomWidth: 1,
//     //             width:'auto',
//     //             alignItems:'center',
//     //             textAlign:'center'
//     //         },
//     //         tbody2: {
//     //             flex: 2,
//     //             borderRightWidth: 1,
//     //         },
//     //         total: {
//     //             fontSize: 9,
//     //             paddingTop: 4,
//     //             paddingLeft: 7,
//     //             flex: 1.5,
//     //             borderColor: 'whitesmoke',
//     //             borderRightWidth: 1,
//     //             borderBottomWidth: 1,
//     //         },
//     //         footerContainer: {
//     //             width: '100%',
//     //             flexDirection: 'row',
//     //             marginTop: 10,
//     //             borderColor: 'whitesmoke',
//     //             borderRightWidth: 1,
//     //             borderBottomWidth: 1,
//     //         },
//     //         footerText: {
//     //             fontWeight: 'bold',
//     //             fontSize: 10,
//     //         },
//     //         note: {
//     //             fontSize: 10,
//     //             fontWeight: 'bold',
//     //             textAlign: 'left',
//     //             color: '#000',

//     //         },

//     //     });

//     //     const InvoiceTitle = () => (
//     //         <View style={styles.titleContainer}>
//     //             <View style={styles.spaceBetween}>
//     //                 <Image style={styles.logo} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSIG9HaZk7zIlMufw_wMjNsya7ALXiecvMdPA&s" />
//     //                 <Text style={[styles.address, { fontSize: 8 }]}>
//     //                     {data?.shipping_address?.house_number}, {data?.shipping_address?.address}, {data?.shipping_address?.floor_number} {"\n"}
//     //                     {data?.shipping_address?.landmark_area}, {data?.shipping_address?.tower_number}, {"\n"}
//     //                     {data?.shipping_address?.city}, {data?.shipping_address?.state}, {data?.shipping_address?.in_pin_code},
//     //                 </Text>
//     //             </View>
//     //         </View>
//     //     );

//     //     const Header = () => (
//     //         <View style={[styles.titleContainer, { justifyContent: 'center', alignItems: 'center', marginVertical: 10 }]}>
//     //             <Text style={{ fontSize: 10, fontWeight: 'bold', textAlign: 'center' }}>TaxInvoice</Text>
//     //         </View>
//     //     );

//     //     const Address = () => (
//     //         <View style={styles.titleContainer}>
//     //             <View style={styles.spaceBetween}>
//     //                 <View>
//     //                     <Text style={styles.invoice}>{data?.company_order_id} </Text>
//     //                     <Text style={styles.invoiceNumber}>{data?.billing_address?.city},{"\n"}
//     //                         {data?.billing_address?.state}
//     //                     </Text>
//     //                 </View>
//     //                 <View>
//     //                     <Text style={[styles.data, { fontSize: 8 }]}>
//     //                         Date            {data?.order_date} {"\n"}
//     //                         Invoice#        {data?.company_id} {"\n"}
//     //                         PAN No.          {data?.shipping_address?.in_pin_code} {"\n"}
//     //                         GST No.          {data?.shipping_address?.in_pin_code} {"\n"}
//     //                         MSME               {data?.shipping_address?.phone_number} {"\n"}
//     //                     </Text>

//     //                 </View>
//     //             </View>
//     //         </View>
//     //     );

//     //     const Account = () => (
//     //         <View style={styles.titleContainer}>
//     //             <View style={styles.spaceBetween}>
//     //                 <View>
//     //                     <Text style={styles.boldAddressTitle}>Account Number</Text>
//     //                     <Text style={styles.boldAddressTitle}>Account Name</Text>
//     //                     <Text style={styles.boldAddressTitle}>Destination Bank Name</Text>
//     //                     <Text style={styles.boldAddressTitle}>Branch</Text>
//     //                     <Text style={styles.boldAddressTitle}>IFSC Code</Text>
//     //                 </View>
//     //                 <View style={{ alignItems: 'flex-end' }}>
//     //                     <Text style={styles.addressTitle}>{data?.order_date}</Text>
//     //                     <Text style={styles.addressTitle}>{data?.company_id}</Text>
//     //                     <Text style={styles.addressTitle}>{data?.shipping_address?.in_pin_code}</Text>
//     //                     <Text style={styles.addressTitle}>{data?.shipping_address?.in_pin_code}</Text>
//     //                     <Text style={styles.addressTitle}>{data?.shipping_address?.phone_number}</Text>
//     //                 </View>
//     //             </View>
//     //         </View>
//     //     );

//     //     const UserAddress = () => (
//     //         <View style={styles.titleContainer}>
//     //             <View style={styles.spaceBetween}>
//     //                 <View style={{ maxWidth: 200 }}>
//     //                     <Text style={styles.boldAddressTitle}>Bill to</Text>
//     //                     <Text style={styles.data?.billing_address?.city}>
//     //                         {data?.billing_address?.name}
//     //                         {data?.billing_address?.address}
//     //                         {data?.billing_address?.city}, {data?.billing_address?.in_pin_code} {"\n"}
//     //                         Phone: {data?.billing_address?.phone_number}
//     //                     </Text>
//     //                 </View>
//     //             </View>
//     //         </View>
//     //     );
//     //     const TableHead = () => (
//     //         <View style={{ width: '100%', flexDirection: 'row', marginTop: 10 }}>
//     //         <View style={[styles.theader]}><Text>Sr. No.</Text></View>
//     //         <View style={styles.theader}><Text>Product</Text></View>
//     //         <View style={styles.theader}><Text>MRP</Text></View>
//     //         <View style={styles.theader}><Text>Discount</Text></View>
//     //         <View style={styles.theader}><Text>QTY</Text></View>
//     //         <View style={styles.theader}><Text>CGST</Text></View>
//     //         <View style={styles.theader}><Text>SGST</Text></View>
//     //         <View style={styles.theader}><Text>IGST</Text></View>
//     //         <View style={styles.theader}><Text>Cess</Text></View>
//     //         <View style={styles.theader}><Text>Total</Text></View>
//     //     </View>
//     //     );

//     //     const TableBody = () => (
//     //         <Fragment>
//     //         {data?.products?.map((product, index) => (
//     //             <View key={index} style={{ flexDirection: 'row', marginVertical: 2 }}>
//     //                 <View style={styles.tbody}><Text>{index + 1}</Text></View>
//     //                 <View style={styles.tbody}><Text>{product.product_name || 'N/A'}</Text></View>
//     //                 <View style={styles.tbody}><Text>{product.item_price || 'N/A'}</Text></View>
//     //                 <View style={styles.tbody}><Text>{data.discount_code || 'N/A'}</Text></View>
//     //                 <View style={styles.tbody}><Text>{product.quantity || 'N/A'}</Text></View>
//     //                 <View style={styles.tbody}><Text>{product.cgst || 'N/A'}</Text></View>
//     //                 <View style={styles.tbody}><Text>{product.sgst || 'N/A'}</Text></View>
//     //                 <View style={styles.tbody}><Text>{product.igst || 'N/A'}</Text></View>
//     //                 <View style={styles.tbody}><Text>{product.cess || 'N/A'}</Text></View>
//     //                 <View style={styles.tbody}><Text>{product.item_price || 'N/A'}</Text></View>
//     //             </View>
//     //         ))}
//     //     </Fragment>
//     //     );

//     //     const TableTotal = () => (
//     //         <View style={styles.footerContainer}>
//     //             <View style={[styles.total, styles.tbody2]}>
//     //                 <Text style={styles.footerText}>IGST @0%</Text>
//     //             </View>
//     //             <View style={styles.tbody}>
//     //                 <Text>0</Text>
//     //             </View>
//     //         </View>
//     //     );

//     //     const TableFooter = () => (
//     //         <View style={[styles.footerContainer, { backgroundColor: '#f0f0f0' }]}>
//     //             <View style={[styles.total, styles.tbody2]}>
//     //                 <Text style={styles.footerText}>Total Amount</Text>
//     //             </View>
//     //             <View style={styles.tbody}>
//     //                 <Text>{data.total_amount}</Text>
//     //             </View>
//     //         </View>
//     //     );

//     //     const AmountWord = () => (
//     //         <View style={[styles.titleContainer, { justifyContent: 'left', alignItems: 'left', marginVertical: 10 }]}>
//     //             <Text style={{ fontSize: 10, fontWeight: 'bold', textAlign: 'center' }}>Amount in words:</Text>
//     //         </View>
//     //     );

//     //     const Note = () => (
//     //         <View style={styles.titleContainer}>
//     //             <Text style={styles.note}>Note:</Text>
//     //             <View style={{ marginBottom: 5 }}>
//     //                 <Text style={styles.note}>
//     //                     1. This invoice is for the Ninth tranche of the advance payment {"\n"}
//     //                     2. Project started on 20th Dec'23 {"\n"}
//     //                     3. Project executed Pan India {"\n"}
//     //                 </Text>

//     //                 <Text style={[styles.note, { marginTop: 20 }]}>
//     //                     In case of cheques, please make cheque payable to Vijaikirti Technologies Pvt Ltd
//     //                 </Text>
//     //                 <Text style={[styles.note, { marginTop: 10, textAlign: 'center' }]}>
//     //                     Thank you for your Business!
//     //                 </Text>
//     //             </View>
//     //         </View>
//     //     );

//     //     return (
//     //         <Document>
//     //             <Page size="A4" style={styles.page}>
//     //                 <View style={styles.borderedContainer}>
//     //                     <InvoiceTitle />
//     //                     <Header />
//     //                     <Address />
//     //                     <Account />
//     //                     <UserAddress />
//     //                     <TableHead />
//     //                     <TableBody />
//     //                     <TableTotal />
//     //                     <TableFooter />
//     //                     <AmountWord />
//     //                     <Note />
//     //                 </View>
//     //             </Page>
//     //         </Document>

//     //     )
//     // }

//     // export default Invoice

//     import React, { Fragment } from 'react';
// import { Image, Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer';

// const Invoice = ({ data }) => {
//     const styles = StyleSheet.create({
//         page: {
//             padding: 20,
//             flexDirection: 'column',
//             margin: 5,
//         },
//         borderedContainer: {
//             fontSize: 10,
//             padding: 20,
//             border: '1px solid #000',
//             flexDirection: 'column',
//         },
//         titleContainer: {
//             flexDirection: 'row',
//             justifyContent: 'center',
//             alignItems: 'center',
//             marginBottom: 10,
//         },
//         logo: {
//             width: 90
//         },
//         headerText: {
//             fontSize: 12,
//             fontWeight: 'bold',
//             textAlign: 'center',
//         },
//         spaceBetween: {
//             flexDirection: 'row',
//             justifyContent: 'space-between',
//             marginTop: 5,
//         },
//         boldText: {
//             fontWeight: 'bold',
//         },
//         address: {
//             fontSize: 9,
//             lineHeight: 1.5,
//         },
//         tableContainer: {
//             marginTop: 10,
//         },
//         tableRow: {
//             flexDirection: 'row',
//             borderBottomWidth: 1,
//             borderBottomColor: '#000',
//             borderBottomStyle: 'solid',
//             paddingVertical: 4,
//             fontSize: 9,
//         },
//         tableHeader: {
//             backgroundColor: '#f0f0f0',
//             fontWeight: 'bold',
//             textAlign: 'center',
//         },
//         tableCol: {
//             flex: 1,
//             textAlign: 'center',
//             padding: 2,
//         },
//         tableTotal: {
//             fontWeight: 'bold',
//             fontSize: 10,
//         },
//         footer: {
//             marginTop: 10,
//             fontSize: 10,
//         },
//         note: {
//             marginTop: 20,
//             fontSize: 10,
//             textAlign: 'center',
//         },
//     });

//     const InvoiceTitle = () => (
//     <View style={[styles.titleContainer, { justifyContent: 'flex-start' }]}>
//         <Image style={styles.logo} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSIG9HaZk7zIlMufw_wMjNsya7ALXiecvMdPA&s" />
//     </View>
// );

//     const Header = () => (
//         <View style={styles.titleContainer}>
//             <Text style={styles.headerText}>Tax Invoice on behalf of </Text>
//         </View>
//     );

//     const SellerDetails = () => (
//         <View style={styles.spaceBetween}>
//             <View>
//                 <Text style={styles.address}>
//                     Order Number: {data?.customer_order_id  || 'Aayush Singh'} {"\n"}
//                     Invoice Number: {data?.invoice_number || 'XXXXX00'} {"\n"}
//                     Order Date: {data?.order_date || '26/10/2024'} {"\n"}
//                     Invoice Date: {data?.invoice_date || '26/10/2024'}
//                 </Text>
//             </View>
//             <View>
//         <Text style={styles.address}>
//         Sold By: {"\n"}
//         {data?.seller_name || 'NISARGA BIOTECH PRIVATE LIMITED'} {"\n"}
//         {data?.seller_address ||
//             'Renaissance industrial sart city Kalyan sape road, \nVashere village, Amane post, \nBhiwandi taluka, Thane district Thane Maharashtra, 421302'} {"\n"}
//         PAN No: {data?.seller_pan || 'AAACN6497K'} {"\n"}
//         GST Registration No: {data?.seller_gst || '27AAACN6497K1ZV'}
//     </Text>
// </View>

//         </View>
//     );

//     const AddressDetails = () => (
//         <View style={[styles.spaceBetween, { marginTop: 10 }]}>
//             <View>
//                 <Text style={styles.address}>
//                     <Text style={[styles.address, styles.boldText]}>Billing Address:</Text> {"\n"}
//                     {data?.billing_address?.name} {"\n"}
//                     {data?.billing_address?.address} {"\n"}
//                     {data?.billing_address?.city}, {data?.billing_address?.state}, {data?.billing_address?.zip}
//                 </Text>
//             </View>
//             <View>
//                 <Text style={styles.address}>
//                     <Text style={[styles.address, styles.boldText]}>Shipping Address:</Text> {"\n"}
//                     {data?.shipping_address?.name} {"\n"}
//                     {data?.shipping_address?.address} {"\n"}
//                     {data?.shipping_address?.city}, {data?.shipping_address?.state}, {data?.shipping_address?.zip}
//                 </Text>
//             </View>
//         </View>
//     );

//     const TableHeader = () => (
//         <View style={[styles.tableRow, styles.tableHeader]}>
//             <Text style={styles.tableCol}>Sr. No.</Text>
//             <Text style={styles.tableCol}>Description</Text>
//             <Text style={styles.tableCol}>Unit Price</Text>
//             <Text style={styles.tableCol}>Qty</Text>
//             <Text style={styles.tableCol}>Net Amount</Text>
//             <Text style={styles.tableCol}>Tax Rate</Text>
//             <Text style={styles.tableCol}>Tax Amount</Text>
//             <Text style={styles.tableCol}>Total</Text>
//         </View>
//     );

//     const TableBody = () => (
//         <Fragment>
//             {data?.products?.map((product, index) => (
//                 <View key={index} style={styles.tableRow}>
//                     <Text style={styles.tableCol}>{index + 1}</Text>
//                     <Text style={styles.tableCol}>{product.product_name}</Text>
//                     <Text style={styles.tableCol}>{product.item_price}</Text>
//                     <Text style={styles.tableCol}>{product.quantity}</Text>
//                     <Text style={styles.tableCol}>{product.item_price * product.quantity}</Text>
//                     <Text style={styles.tableCol}>{data.discount_code || '0'}</Text>
//                     <Text style={styles.tableCol}>{product.tax_amount || '0'}</Text>
//                     <Text style={styles.tableCol}>{data.total_amount ||'0'}</Text>
//                 </View>
//             ))}
//         </Fragment>
//     );

//     const PaymentDetails = () => (
//         <View style={[styles.spaceBetween, { marginTop: 10, borderTop: '1px solid #000', paddingTop: 10 }]}>
//             <View>
//                 <Text style={styles.address}>
//                     Payment Transaction ID: {data?.payment_transaction_id || "rJKOfekqMadIWKGAU2c7wyxuD"} {"\n"}
//                     Date & Time: {data?.date_time || "26/10/2024"} {"\n"}
//                     Invoice Value: ₹{data.total_amount} {"\n"}
//                     Mode of Payment: {data?.payment_mode || "UPI"}
//                 </Text>
//             </View>
//         </View>
//     );

//     const AuthorizedSignatory = () => (
//         <View style={[styles.spaceBetween, { marginTop: 20, alignItems: 'flex-end' }]}>
//             <View style={{ flex: 1, alignItems: 'flex-end' }}>
//                 <Text style={{ fontSize: 10, fontWeight: 'bold' }}>
//                     For {data?.seller_name || "NISARGA BIOTECH PRIVATE LIMITED"}
//                 </Text>
//                 {/* <Image
//                     style={{ width: 80, height: 80 }}
//                     src="https://mdimages.s3.amazonaws.com/1729925489156stamp.jpg"
//                 />
//                 <Text style={{ fontSize: 10, marginTop: 5 }}>Authorized Signatory</Text> */}
//             </View>
//         </View>
//     );

//     const TableFooter = () => (
//         <View style={[styles.tableRow, { fontWeight: 'bold' }]}>
//             <Text style={styles.tableCol}>Total</Text>
//             <Text style={[styles.tableCol, { textAlign: 'right' }]}>{data.total_amount}</Text>
//         </View>
//     );

//     const numberToWords = (num) => {
//         const belowTwenty = [
//             "Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
//             "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//             "Seventeen", "Eighteen", "Nineteen"
//         ];
//         const tens = [
//             "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
//         ];
//         const aboveThousand = [
//             "", "Thousand", "Million", "Billion", "Trillion"
//         ];

//         if (num === 0) return "Zero";

//         let word = '';
//         let i = 0;

//         while (num > 0) {
//             if (num % 1000 !== 0) {
//                 word = helper(num % 1000) + aboveThousand[i] + " " + word;
//             }
//             num = Math.floor(num / 1000);
//             i++;
//         }

//         return word.trim();

//         function helper(n) {
//             if (n === 0) return "";
//             else if (n < 20) return belowTwenty[n] + " ";
//             else if (n < 100) return tens[Math.floor(n / 10)] + " " + helper(n % 10);
//             else return belowTwenty[Math.floor(n / 100)] + " Hundred " + helper(n % 100);
//         }
//     };

//     const Footer2 = ({ amount }) => (
//         <View style={styles.footer}>
//             <Text>Amount in Words: {numberToWords(data.total_amount)}</Text>
//         </View>
//     );

//     const Footer = () => (
//         <View style={styles.footer}>
//             <Text style={styles.note}>Thank you for your Business!</Text>
//         </View>
//     );

//     return (
//         <Document>
//             <Page size="A4" style={styles.page}>
//                 <View style={styles.borderedContainer}>
//                     <InvoiceTitle/>
//                     <Header />
//                     <SellerDetails />
//                     <AddressDetails />
//                     <View style={styles.tableContainer}>
//                         <TableHeader />
//                         <TableBody />
//                         <TableFooter />
//                     </View>
//                     <Footer2 />
//                     <AuthorizedSignatory />
//                     <PaymentDetails />
//                     <Footer />
//                 </View>
//             </Page>
//         </Document>
//     );
// };

// export default Invoice;

import jsPDF from 'jspdf';

const numberToWords = (num) => {
  const belowTwenty = [
    'Zero',
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten',
    'Eleven',
    'Twelve',
    'Thirteen',
    'Fourteen',
    'Fifteen',
    'Sixteen',
    'Seventeen',
    'Eighteen',
    'Nineteen',
  ];
  const tens = [
    '',
    '',
    'Twenty',
    'Thirty',
    'Forty',
    'Fifty',
    'Sixty',
    'Seventy',
    'Eighty',
    'Ninety',
  ];
  const aboveThousand = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

  if (!num || num === 0) return 'Zero';
  num = parseInt(num);
  let word = '';
  let i = 0;

  while (num > 0) {
    if (num % 1000 !== 0) word = helper(num % 1000) + aboveThousand[i] + ' ' + word;
    num = Math.floor(num / 1000);
    i++;
  }
  return word.trim();

  function helper(n) {
    if (n === 0) return '';
    else if (n < 20) return belowTwenty[n] + ' ';
    else if (n < 100) return tens[Math.floor(n / 10)] + ' ' + helper(n % 10);
    else return belowTwenty[Math.floor(n / 100)] + ' Hundred ' + helper(n % 100);
  }
};

const loadImage = (url) =>
  new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext('2d').drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = () => resolve(null);
    img.src = url;
  });

export const generateInvoicePDF = async (data) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const leftX = 14;
  const rightX = pageWidth / 2 + 10;
  const contentWidth = pageWidth - 28; // for border padding

  // ── Outer Border ─────────────────────────────────────
  doc.setDrawColor(0);
  doc.setLineWidth(0.5);
  doc.rect(10, 10, pageWidth - 20, pageHeight - 20);

  let y = 18;

  // ── Logo (top-left, same as InvoiceTitle) ────────────
  const logoUrl =
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSIG9HaZk7zIlMufw_wMjNsya7ALXiecvMdPA&s';
  const logoData = await loadImage(logoUrl);
  if (logoData) {
    doc.addImage(logoData, 'PNG', leftX, y, 38, 14);
  }
  y += 20;

  // ── Header: "Tax Invoice on behalf of" ───────────────
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('Tax Invoice on behalf of', pageWidth / 2, y, { align: 'center' });
  y += 10;

  // ── Seller Details (left) + Order Info (right) ───────
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');

  // Left: Order info
  const orderLines = [
    `Order Number: ${data?.customer_order_id || 'XXXXX00'}`,
    `Invoice Number: ${data?.invoice_number || 'XXXXX00'}`,
    `Order Date: ${data?.order_date || '26/10/2024'}`,
    `Invoice Date: ${data?.invoice_date || '26/10/2024'}`,
  ];
  orderLines.forEach((line, i) => {
    doc.text(line, leftX, y + i * 5);
  });

  // Right: Sold By
  const sellerY = y;
  doc.text('Sold By:', rightX, sellerY);
  doc.text(`${data?.seller_name || 'NISARGA BIOTECH PRIVATE LIMITED'}`, rightX, sellerY + 5);
  const sellerAddrText =
    data?.seller_address ||
    'Renaissance industrial sart city Kalyan sape road, Vashere village, Amane post, Bhiwandi taluka, Thane district Thane Maharashtra, 421302';
  const sellerAddrLines = doc.splitTextToSize(sellerAddrText, 85);
  doc.text(sellerAddrLines, rightX, sellerY + 10);
  const addrOffset = sellerAddrLines.length * 4.5;
  doc.text(`PAN No: ${data?.seller_pan || 'AAACN6497K'}`, rightX, sellerY + 10 + addrOffset);
  doc.text(
    `GST Registration No: ${data?.seller_gst || '27AAACN6497K1ZV'}`,
    rightX,
    sellerY + 15 + addrOffset
  );

  y += 28;

  // ── Divider ──────────────────────────────────────────
  doc.setDrawColor(180);
  doc.line(leftX, y, pageWidth - leftX, y);
  y += 6;

  // ── Billing & Shipping Address ───────────────────────
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.text('Billing Address:', leftX, y);
  doc.text('Shipping Address:', rightX, y);

  doc.setFont('helvetica', 'normal');
  const billLines = [
    data?.billing_address?.name || '',
    data?.billing_address?.address || '',
    `${data?.billing_address?.city || ''}, ${data?.billing_address?.state || ''}, ${data?.billing_address?.zip || ''}`,
  ];
  const shipLines = [
    data?.shipping_address?.name || '',
    data?.shipping_address?.address || '',
    `${data?.shipping_address?.city || ''}, ${data?.shipping_address?.state || ''}, ${data?.shipping_address?.zip || ''}`,
  ];
  billLines.forEach((line, i) => doc.text(line, leftX, y + 5 + i * 5));
  shipLines.forEach((line, i) => doc.text(line, rightX, y + 5 + i * 5));
  y += 24;

  // ── Divider ──────────────────────────────────────────
  doc.setDrawColor(180);
  doc.line(leftX, y, pageWidth - leftX, y);
  y += 6;

  // ── Table ────────────────────────────────────────────
  // ── Table ────────────────────────────────────────────
  const colWidths = [12, 45, 22, 12, 24, 18, 18, 22];
  const headers = [
    'Sr. No.',
    'Description',
    'Unit Price',
    'Qty',
    'Net Amount',
    'Tax Rate',
    'Tax Amount',
    'Total',
  ];
  const rowHeight = 8;
  const tableStartX = leftX;
  const totalTableWidth = colWidths.reduce((a, b) => a + b, 0);

  const drawRow = (cols, rowY, isBold = false, isHeader = false) => {
    const descriptionText = String(cols[1] ?? '');
    const descLines = doc.splitTextToSize(descriptionText, colWidths[1] - 4);
    const lineHeight = 4.5;
    const cellHeight = Math.max(rowHeight, descLines.length * lineHeight + 3);

    if (isHeader) {
      doc.setFillColor(240, 240, 240);
      doc.rect(tableStartX, rowY - 5.5, totalTableWidth, cellHeight, 'F');
    }

    doc.setFont('helvetica', isBold ? 'bold' : 'normal');
    doc.setFontSize(8);

    let x = tableStartX;
    cols.forEach((col, i) => {
      if (i > 0) {
        doc.setDrawColor(180);
        doc.setLineWidth(0.2);
        doc.line(x, rowY - 5.5, x, rowY + cellHeight - 5.5);
      }
      doc.setTextColor(0);
      if (i === 1) {
        doc.text(descLines, x + 2, rowY, { maxWidth: colWidths[i] - 4 });
      } else {
        doc.text(String(col ?? ''), x + colWidths[i] / 2, rowY, { align: 'center' });
      }
      x += colWidths[i];
    });

    doc.setDrawColor(0);
    doc.setLineWidth(0.2);
    doc.line(
      tableStartX,
      rowY + cellHeight - 5.5,
      tableStartX + totalTableWidth,
      rowY + cellHeight - 5.5
    );

    return cellHeight;
  };

  const tableTopY = y;

  // ── Header row
  const headerHeight = drawRow(headers, y, true, true);
  y += headerHeight;

  // ── Body rows ──
  (data?.products || []).forEach((product, index) => {
    const rowUsedHeight = drawRow(
      [
        index + 1,
        product.product_name,
        product.item_price,
        product.quantity,
        product.item_price * product.quantity,
        data.discount_code || '0',
        product.tax_amount || '0',
        data.total_amount || '0',
      ],
      y
    );
    y += rowUsedHeight;
  });

  // ── Total row ──
  const totalRowY = y;
  doc.setFillColor(240, 240, 240);
  doc.rect(tableStartX, totalRowY - 5.5, totalTableWidth, rowHeight, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8);
  doc.setTextColor(0);
  doc.text('Total', tableStartX + colWidths[0] / 2, totalRowY, { align: 'center' });
  const lastColX = colWidths.slice(0, 7).reduce((a, b) => a + b, tableStartX);
  doc.text(String(data.total_amount ?? '0'), lastColX + colWidths[7] / 2, totalRowY, {
    align: 'center',
  });
  doc.setDrawColor(0);
  doc.setLineWidth(0.2);
  doc.line(tableStartX, totalRowY + 2.5, tableStartX + totalTableWidth, totalRowY + 2.5);

  // ── Outer table border ──
  doc.setDrawColor(0);
  doc.setLineWidth(0.3);
  doc.rect(tableStartX, tableTopY - 5.5, totalTableWidth, totalRowY - tableTopY + rowHeight);

  y = totalRowY + rowHeight + 8;

  // ── Amount in Words ──────────────────────────────────
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text(`Amount in Words: ${numberToWords(data.total_amount)}`, leftX, y);
  y += 12;

  // ── Authorized Signatory (right aligned) ─────────────
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text(`For ${data?.seller_name || 'NISARGA BIOTECH PRIVATE LIMITED'}`, pageWidth - leftX, y, {
    align: 'right',
  });
  y += 15;

  // ── Payment Details (with top border) ────────────────
  doc.setDrawColor(0);
  doc.setLineWidth(0.3);
  doc.line(leftX, y - 4, pageWidth - leftX, y - 4);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  [
    `Payment Transaction ID: ${data?.payment_transaction_id || 'rJKOfekqMadIWKGAU2c7wyxuD'}`,
    `Date & Time: ${data?.date_time || '26/10/2024'}`,
    `Invoice Value: Rs.${data.total_amount}`,
    `Mode of Payment: ${data?.payment_mode || 'UPI'}`,
  ].forEach((line, i) => {
    doc.text(line, leftX, y + i * 5);
  });
  y += 28;

  // ── Footer ───────────────────────────────────────────
  doc.setFontSize(10);
  doc.setFont('helvetica', 'italic');
  doc.text('Thank you for your Business!', pageWidth / 2, y, { align: 'center' });

  return doc;
};

export default { generateInvoicePDF };
